import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import { breakpointPropShape } from '../helpers';

const generateCardoContentWrapperClassNames = ({
  contentAlignment,
  contentOverlay,
  isContentFirst,
  xsmall,
  small,
  medium,
  large,
  xlarge,
}) => classNames(
  'cell',
  {
    [`xsmall-${R.path(['gridSetup', 'content', 'columns'], xsmall)}`]: (
      R.path(['gridSetup', 'content', 'columns'], xsmall)
    ),
    [`small-${R.path(['gridSetup', 'content', 'columns'], small)}`]: (
      R.path(['gridSetup', 'content', 'columns'], small)
    ),
    [`medium-${R.path(['gridSetup', 'content', 'columns'], medium)}`]: (
      R.path(['gridSetup', 'content', 'columns'], medium)
    ),
    [`large-${R.path(['gridSetup', 'content', 'columns'], large)}`]: (
      R.path(['gridSetup', 'content', 'columns'], large)
    ),
    [`xlarge-${R.path(['gridSetup', 'content', 'columns'], xlarge)}`]: (
      R.path(['gridSetup', 'content', 'columns'], xlarge)
    ),
  },
  // TODO content box padding (this is done in CSS now...?)
  'cardo__content-wrapper',
  {
    'cardo__content-wrapper--content-first': isContentFirst,
    'cardo__content-wrapper--content-last': !isContentFirst,
    'cardo__content-wrapper--no-overlay': !contentOverlay,
    'cardo__content-wrapper--overlay': contentOverlay,
    'cardo__content-wrapper--align-left': contentAlignment.horizontal === 'left',
    'cardo__content-wrapper--align-middle': contentAlignment.horizontal === 'middle',
    'cardo__content-wrapper--align-right': contentAlignment.horizontal === 'right',
    'cardo__content-wrapper--overlay-outside-top': (
      contentOverlay && contentOverlay.verticalOffsetType === 'outside' && contentAlignment.vertical === 'top'
    ),
    'cardo__content-wrapper--overlay-outside-bottom': (
      contentOverlay && contentOverlay.verticalOffsetType === 'outside' && contentAlignment.vertical === 'bottom'
    ),
    'cardo__content-wrapper--overlay-inside-bottom': (
      contentOverlay && contentOverlay.verticalOffsetType === 'inside' && contentAlignment.vertical === 'bottom'
    ),
    'cardo__content-wrapper--overlay-inside-middle': (
      contentOverlay && contentOverlay.verticalOffsetType === 'inside' && contentAlignment.vertical === 'middle'
    ),
    'cardo__content-wrapper--overlay-inside-top': (
      contentOverlay && contentOverlay.verticalOffsetType === 'inside' && contentAlignment.vertical === 'top'
    ),
  },
);

const CardoContentWrapper = ({
  contentAlignment,
  contentOverlay,
  isContentFirst,
  currentBreakpoint,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  children,
}) => (
  <div
    className={generateCardoContentWrapperClassNames({
      contentAlignment,
      contentOverlay,
      isContentFirst,
      currentBreakpoint,
      xsmall,
      small,
      medium,
      large,
      xlarge,
    })}
  >
    {children}
  </div>
);

CardoContentWrapper.propTypes = {
  contentAlignment: PropTypes.objectOf(PropTypes.string).isRequired,
  contentOverlay: PropTypes.shape({
    coverImage: PropTypes.bool.isRequired,
    verticalOffsetType: PropTypes.string.isRequired,
    horizontalOffset: PropTypes.bool.isRequired, // TODO: [1] not currently used. Check if needed for cards or just hero
  }),
  isContentFirst: PropTypes.bool.isRequired,
  currentBreakpoint: PropTypes.string.isRequired,
  xsmall: breakpointPropShape,
  small: breakpointPropShape,
  medium: breakpointPropShape,
  large: breakpointPropShape,
  xlarge: breakpointPropShape,
  children: PropTypes.node.isRequired,
};

export default CardoContentWrapper;
